import * as React from 'react';
export const IcSign = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.3 3.7a12.88 12.88 0 00-8.45 0 13.1 13.1 0 00-8.16 16.62 1 1 0 00.95.68c.12.017.24.017.36 0a1 1 0 00.62-1.27 11.74 11.74 0 01-.48-2.13c.791.15 1.594.228 2.4.23a13.47 13.47 0 007.28-2.12 1 1 0 00.39-1.15L14 11l4.06.68a1 1 0 001-.46A13.53 13.53 0 0021 4.67a1 1 0 00-.7-.97z'
      fill='currentColor'
    />
  </svg>
);
